<div class="page-wrapper pt-5">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="actions-row">

                    <div class="d-flex justify-content-center mb-4">
                        <mat-button-toggle-group #toggleGroup1="matButtonToggleGroup"
                            (change)="tabChange(toggleGroup1.value)" name="fontStyle" aria-label="Delegates"
                            [value]="tab">
                            <mat-button-toggle value="delegates">Delegates</mat-button-toggle>
                        </mat-button-toggle-group>
                    </div>
                </div>
                <div class="contents-table mat-elevation-z4">
                    <!-- delegates Table -->
                    <table mat-table matSort [dataSource]="delegatesDataSource" class="w-100"
                        *ngIf="tab === 'delegates'">
                        <caption>Delegates</caption>
                        <!-- Id Column -->
                        <ng-container matColumnDef="id">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef mat-sort-header
                                sortActionDescription="Sort by Id"> Id </th>
                            <td mat-cell *matCellDef="let element"> {{element.id}} </td>
                        </ng-container>

                        <!-- First Name Column -->
                        <ng-container matColumnDef="firstName">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef mat-sort-header
                                sortActionDescription="Sort by First Name"> Nome
                            </th>
                            <td mat-cell *matCellDef="let element"> {{element.firstName}} </td>
                        </ng-container>

                        <!-- Last Name Column -->
                        <ng-container matColumnDef="lastName">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef mat-sort-header
                                sortActionDescription="Sort by Last Name">
                                Cognome </th>
                            <td mat-cell *matCellDef="let element"> {{element.lastName}} </td>
                        </ng-container>

                        <!-- Email Column -->
                        <ng-container matColumnDef="email">
                            <th mat-header-cell class="user-select-none font-15" *matHeaderCellDef> Email </th>
                            <td mat-cell *matCellDef="let element"> {{element.email}} </td>
                        </ng-container>

                        <!-- Delete Column -->
                        <ng-container matColumnDef="delete">
                            <th mat-header-cell class="text-center user-select-none font-15" *matHeaderCellDef>
                                {{'PENDING_REQUEST_INFO.DELETE' | translate}} </th>
                            <td mat-cell *matCellDef="let element" class="text-center">
                                <fa-icon (click)="removeDelegateModal(element)" class="cursor-pointer withdraw-btn"
                                    [icon]="faTrash"></fa-icon>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumnsDelegates; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsDelegates;"></tr>
                        <!-- Row shown when there is no matching data. -->
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="4">{{'NO_RESULT' | translate}}</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 d-flex justify-content-center mt-4">
                <button (click)="createDelegateModal()" mat-flat-button class="btn-action primary new-request-btn">
                    {{'DELEGATES.ADD_COLLABORATOR' | translate}}</button>
            </div>
        </div>
    </div>
</div>